module.exports = __webpack_public_path__ + "img/play-button.e22e64e0.png";